import { render, staticRenderFns } from "./Overdraft.vue?vue&type=template&id=2e661059&scoped=true&"
import script from "./Overdraft.vue?vue&type=script&lang=js&"
export * from "./Overdraft.vue?vue&type=script&lang=js&"
import style0 from "./Overdraft.vue?vue&type=style&index=0&id=2e661059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e661059",
  null
  
)

export default component.exports